import { render } from "./Returned.vue?vue&type=template&id=e7d36026"
import script from "./Returned.vue?vue&type=script&lang=js"
export * from "./Returned.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__